import { IMapModel } from './interfaces/IMapModel';
import { GCoordinate } from '../gmap/gcoordinate.model';
import { GMarker } from '../gmap/gmarker.model';

export class BaseMapModel implements IMapModel {
    title: string;
    type: "Marker" | "Cluster" | "Road";
    polygonColor: string;
    initZoom: number;
    initCoordinate: GCoordinate
    markers: GMarker[] ;

    constructor(){
        const defaultCoordinate = new GCoordinate();
        defaultCoordinate.latitude  = 41.00692276948323;
        defaultCoordinate.longitude = 28.97504526238309;
        
        this.title = "";        
        this.initZoom = 15;
        this.polygonColor = "#1E90FF";
        this.initCoordinate = defaultCoordinate;
        this.markers = [];
    }
}